import React from 'react';
import { ConstantPermissions } from 'contexts/useConstant';
import Customer from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/IncompleteBusinessPartner';

export default function () {
  return (
    <Customer
      cardType="C"
      entity="base/business-partner/incomplete"
      permissions={{
        store: ConstantPermissions.BASE_BUSINESS_PARTNERS_STORE,
        show: ConstantPermissions.BASE_BUSINESS_PARTNERS_SHOW,
      }}
    />
  );
}
